module.exports = __webpack_public_path__ + "img/icon150alpha.7ce43427.png";